import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromIdle from '../../reducers/idle/idle.reducer';

export const IdleTime = 600; // 10 minutes
export const Timeout = 30; // 30 seconds
//
export const selectIdleState = createFeatureSelector<fromIdle.State>(
  fromIdle.idleFeatureKey
);

export const selectIdleWarning = createSelector(
  selectIdleState,
  (state: fromIdle.State) => state.idleWarning
);
export const selectIdleWarningText = createSelector(
    selectIdleState,
  (state: fromIdle.State) => 'You will time out in ' + (Timeout - state.idleValue) + ' seconds!'
);
export const selectIdleValueAsPercent = createSelector(
    selectIdleState,
    (state: fromIdle.State) => (state.idleValue/Timeout)  * 100
);
